import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerFirstOrderIncentiveTermsAndConditionsLearnMoreClick } from "@faire/web-api--source/events/retailerFirstOrderIncentive/click/termsAndConditionsLearnMore";
import React from "react";
import { useHistory } from "react-router-dom";
import { FIRST_ORDER_INCENTIVE_MODAL } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { useBannerText } from "./__internal__/useBannerText";
export var FirstOrderIncentiveBanner = function() {
    var history = useHistory();
    var bannerText = useBannerText();
    var onLearnMoreClick = function() {
        trackRetailerFirstOrderIncentiveTermsAndConditionsLearnMoreClick();
        history.replace(getCurrentPath().append({
            show_modal: FIRST_ORDER_INCENTIVE_MODAL
        }).toString());
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Typography, {
            align: "center",
            "data-test-id": "first-order-incentive-banner",
            children: [
                bannerText,
                " ",
                /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    onClick: onLearnMoreClick,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "rJAsDE",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "View details"
                            }
                        ]
                    })
                })
            ]
        })
    });
};
